import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { KNOWLEDGE_BASE_ARTICLES } from './knowledge-base.catalog';
import { kbArticleLink } from './knowledge-base.links';

/**
 * Catch-all for unknown ``/knowledge-base/**`` URLs.
 *
 * Articles are addressed as ``<category>/<slug>``, so renaming a category breaks
 * every old link into it. When the last segment still names a known article we
 * send the reader there; anything else lands on the index instead of the app's
 * generic 404.
 */
export const knowledgeBaseNotFoundGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const path = state.url.split(/[?#]/)[0];
  const lastSegment = path.split('/').filter(Boolean).pop();
  const article = KNOWLEDGE_BASE_ARTICLES.find((a) => a.slug === lastSegment);

  return router.createUrlTree(article ? kbArticleLink(article) : ['/knowledge-base']);
};
